import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { RouterProvider } from "@tanstack/react-router";
import { router } from "./routes/router.tsx";

import { AuthProvider } from "./context/AuthContext.tsx";
import { QueryClientProvider } from "@tanstack/react-query";
import queryClient from "./queryClient.ts";
import useAuth from "./hooks/useAuth.ts";
import { Toaster } from "@/components/ui/toaster";
import { polishErrorMap } from "./components/Form/schemas.ts";
import { z } from "zod";

// UWAGA: NIE wołamy tu initProjectionDefinitions() na top-levelu.
// W produkcyjnym buildzie Vite synchroniczne użycie proj4 (CJS) na top-levelu main.tsx
// potrafi wywołać TDZ "Cannot access 'X' before initialization" ze względu na kolejność
// inicjalizacji modułów w bundlu. Inicjalizacja jest odroczona — `getProj4()` oraz
// `registerProj4WithOpenLayers()` wołają `initProjectionDefinitions()` leniwie przy
// pierwszym użyciu (w OlMap w async useEffect, w ULDK w event handlerze).

z.setErrorMap(polishErrorMap);

function InnerApp() {
  const { auth } = useAuth();
  return <RouterProvider router={router} context={auth} />;
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Toaster />
        <InnerApp />
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
